<template>
  <div :class="`formulate-input-element formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <h2 v-html="context.attributes.children"></h2>
    <div v-html="context.attributes.declarationhtml"></div>
    <br />
    <p>By signing I/we understand the <a href="#" @click.prevent="toggleModal('/disclosure-statement/?plain=true')">Duty of Disclosure</a>
        and agree with the initio <a href="#" @click.prevent="toggleModal('/terms-and-conditions/?plain=true')">Terms &amp; Conditions</a>
        and <a href="#" @click.prevent="toggleModal('/privacy-policy?plain=true')">Privacy Policy</a>.</p>

    <div class="modal" :class="{ 'is-active': modalOpen }" v-if="modalOpen">
      <div class="modal-background" @click.prevent="toggleModal()"></div>
      <div class="modal-content">
        <button @click.prevent="toggleModal()" class="delete is-large" aria-label="close"></button>
        <!-- Any other Bulma elements you want -->
        <div class="box content">
          <div v-if="!modelContent">Loading...</div>
          <div v-if="modelContent" v-html="modelContent"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios";

export default {
  props: {
    context: {
      type: Object,
      required: true
    },
  },
  data: function () {
    return {
      modalOpen: false,
      modelContent: '',
    }
  },
  watch: {

  },
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers',
      answerLabel: 'getAnswerLabel'
    }),

  },
  methods: {
      toggleModal: function(url) {
        this.modelContent = '';
        let self = this;
        if( url ){
          axios.post(url, {})
          .then((response) => {
            self.modelContent = response.data
          }, (error) => {
            console.error("Cannot get modal content with URL", url, error);
            self.modelContent = 'Error: Failed to load content';
          });
        }
        this.modalOpen = ! this.modalOpen;
    }
  },
}
</script>

<style lang="scss">
  .panel--declaration {
    div[data-type=declaration] {
      h2 {
        font-weight:900;
        font-size:1rem;
      }
      ul {
        list-style-type: lower-alpha;
        padding-left:1.5rem;
      }
      li {
        font-size:0.875rem;
        line-height:1.75rem;
        list-style-type: lower-alpha;
      }
    }
  }

</style>
